import React from 'react';
import styles from './Layout.module.css';

const Layout = ({ children }) => {
    return (
        <div className={styles.container}>
            {/* Фоновые элементы */}
            <div className={styles.ellipse}></div>
            <div className={styles.innerEllipse}></div>
            <div className={styles.ellipse2}></div>
            <div className={styles.innerEllipse2}></div>
            <div className={styles.ellipse3}></div>
            <div className={styles.innerEllipse3}></div>

            {/* Контент страницы */}
            <div className={styles.content}>
                {children}
            </div>
        </div>
    );
}

export default Layout;